import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import axios from 'axios';

interface IApplicationInfo {
    application: string;
    applicationVersion: string;
}

export interface IApplicationInfoInterceptor {
    gatherInfo(): IApplicationInfo;
    initialise(): void;
    cleanup(): void;
}

export class ApplicationInfoInterceptor implements IApplicationInfoInterceptor {
    private interceptorId: number | null = null;

    constructor(
        private configurationValuesService: IConfigurationValuesService
    ) {

    }

    gatherInfo(): IApplicationInfo {
        const {
            version,
            applicationName
        } = this.configurationValuesService;

        return {
            application: applicationName,
            applicationVersion: version
        };
    }

    initialise(): void {
        this.interceptorId = axios.interceptors.request.use(request => ({
            ...request,
            headers: {
                ...request.headers,
                'Application-Info': JSON.stringify(this.gatherInfo())
            }
        }));
    }

    cleanup(): void {
        if (this.interceptorId !== null) {
            axios.interceptors.request.eject(this.interceptorId);
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/http/application-info-interceptor.ts